export default __webpack_public_path__ + "static/media/footer-Logo.2f87d3aa.svg";